import React, { useEffect, useRef } from "react";
import Header from "../../components/common/Header";
import { Link } from "react-router-dom";
// Import GSAP
import { gsap } from "gsap";

const HeroSection = () => {
  // 1. Create refs for the elements
  const topBgRef = useRef(null);
  const topTextRef = useRef(null);
  const bottomBgRef = useRef(null);
  const bottomContentRef = useRef(null);
  const logoRef = useRef(null);

  useEffect(() => {
    // 2. Set up GSAP context
    const context = gsap.context(() => {
      const tl = gsap.timeline({
        defaults: { ease: "power3.out", duration: 1.2 },
      });

      // ----------------------------------------------------
      // A. Top Background Entrance (Optional subtle fade/scale)
      // ----------------------------------------------------
      if (topBgRef.current) {
        tl.from(
          topBgRef.current,
          {
            opacity: 0.8,
            scale: 1.05,
            duration: 1.5,
          },
          0,
        ); // Start immediately
      }

      // ----------------------------------------------------
      // B. Top Text Entrance (Staggered Slide Up)
      // ----------------------------------------------------
      if (topTextRef.current) {
        const topLines = gsap.utils.toArray(topTextRef.current.children);
        tl.from(
          topLines,
          {
            y: 50,
            opacity: 0,
            stagger: 0.2,
            duration: 1.2,
          },
          0.2,
        ); // Start shortly after the background
      }

      // ----------------------------------------------------
      // C. Bottom Image Container Entrance (Dramatic Slide Up)
      // ----------------------------------------------------
      // Animate the bottom image area (which covers the bottom part of the screen)
      if (bottomBgRef.current) {
        tl.from(
          bottomBgRef.current,
          {
            yPercent: 10, // Start slightly below its final position
            opacity: 0,
            duration: 1.8,
            ease: "power3.inOut",
          },
          0.5,
        ); // Start after the top text is well underway
      }

      // ----------------------------------------------------
      // D. Bottom Content & Logo Entrance
      // ----------------------------------------------------
      if (bottomContentRef.current) {
        const bottomText =
          bottomContentRef.current.querySelector(".bottom-text");

        // Logo fade in (the spinning animation is handled by CSS)
        tl.from(
          logoRef.current,
          {
            opacity: 0,
            scale: 0.5,
            duration: 1,
          },
          1.5,
        ); // Start after the bottom image is almost in place

        // Text slide up
        tl.from(
          bottomText,
          {
            y: 20,
            opacity: 0,
            duration: 1,
          },
          1.7,
        ); // Start after the logo
      }
    }, [topBgRef, bottomBgRef, topTextRef, bottomContentRef, logoRef]);

    // 3. Cleanup
    return () => context.revert();
  }, []);

  return (
    <section className="relative w-full ">
      {/* Hero Background Container - Attach Ref */}

      <div
        ref={topBgRef}
        className="relative w-full h-[100vh]  bg-cover bg-center bg-no-repeat z-[9999] "
        style={{
          backgroundImage: "url('/assets/homeImg/herobgtop1.png')",
        }}
      >
        <Header />
        {/* <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/20"></div> */}

        <div className="relative z-10 w-full max-w-[1620px] mx-auto px-4 sm:px-6 xl:px-8 h-full flex flex-col mt-[50px] items-center">
          <div
            ref={topTextRef}
            className="text-center space-y-4 xl:space-y-0 xl:-space-y-5"
          >
            {/* Top Text Lines */}
            <h1 className="text-[48px] sm:text-[60px] xl:text-[80px] 2xl:text-3xl font-bold text-secondary-text font-['Parkinsans']">
              Organic Agriculture
            </h1>
            <h2 className="text-[48px] sm:text-[60px] xl:text-[80px] 2xl:text-3xl font-bold text-secondary-text font-['Parkinsans']">
              Solution
            </h2>
          </div>
        </div>
      </div>

      {/* About Utpann Overlay Section - Attach Ref */}
      <div
        ref={bottomBgRef}
        className="relative w-full z-0 h-[400px] sm:h-[500px] md:h-[600px] xl:h-[1076px] -mt-[400px] sm:-mt-[250px] md:-mt-[300px] xl:-mt-[528px] bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/assets/homeImg/herobgbottom.png')",
          zIndex: "110",
        }}
      >
        {/* <div className="absolute inset-0 bg-gradient-to-t from-background-dark via-background-dark/80 to-transparent"></div> */}

        {/*    */}
      </div>
    </section>
  );
};

export default HeroSection;
